export default "__VITE_ASSET__59V5P0nlnSpKXSIm6l5mmA__"